// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__0P8U3","pageLink":"Pagination_pageLink___7kQe","pageLinkActive":"Pagination_pageLinkActive___ns29"};